import { DOSIER_DETAIL_FETCH_DOSIER_DATA } from '../constants/dosierDetail';
import { FAIL, START, SUCCESS } from '../constants';

export const startFetchingDosierData = () => ({ type: DOSIER_DETAIL_FETCH_DOSIER_DATA + START });

export const setDosierData = (dosierData) => ({
	type: DOSIER_DETAIL_FETCH_DOSIER_DATA + SUCCESS,
	payload: { dosierData },
});

export const fetchingDosierDataError = () => ({ type: DOSIER_DETAIL_FETCH_DOSIER_DATA + FAIL });
